import { Grid, Paper } from '@mui/material'
import { FormDescriptionTypographyPDF, FormTitleTypographyPDF } from '../../../../components/CustomStyles/StyledComponents';
import { ENTERPRISE_DETAILED_TABLES } from '../../../../constants/shellTables';
import DataTable from '../../../../components/Results/ResultsDataTable';

const Tables = ({ results = {}, firstChild = false }) => {
    return (
        <Paper sx={{ maxWidth: '860px', pageBreakBefore: 'always', pageBreakAfter: 'auto', marginTop: '4mm', borderRadius: 0,}} p={2}>
            <Grid item xs={12}>
                <Paper sx={{ p: 0, display: 'flex', flexDirection: 'column', marginTop: '3mm', borderRadius: 0,}}>
                    <FormTitleTypographyPDF fontSize={20} variant="h6" component="div" mb={1}>
                        {`Enterprise Emissions: ${results.enterpriseTitle}`}
                    </FormTitleTypographyPDF>
                    <FormDescriptionTypographyPDF variant="body2" fontSize={10} paragraph mb={1}>
                        {`The quick glance table below displays a breakdown of product-level emissions by source against the 
                        average benchmark value. The opportunity level (high, medium, or low) suggests the likelihood of cost effective improvement in for each emission source.`}
                    </FormDescriptionTypographyPDF>
                    <FormDescriptionTypographyPDF variant="body2" fontSize={10} paragraph mb={0}>
                        {`The physical performance table helps place emission results in context, by benchmarking enterprise 
                        KPIs against average values. This table should help evaluate the overall efficiency of the enterprise.`}
                    </FormDescriptionTypographyPDF>
                </Paper>
            </Grid>
            <Grid item xs={12}>
                <Grid container direction='column'>
                    {ENTERPRISE_DETAILED_TABLES.map((table, index) => (
                        // results[table.key] && results[table.key].length > 0 &&
                        <Grid item key={index} xs={12} sx={{
                            pageBreakInside: 'avoid',
                            //pageBreakAfter: index === 0 ? 'always' : 'auto'
                        }}>
                            <DataTable
                                tableId={index}
                                tableData={table}
                                resultsData={results[table.key]}
                                media='print'
                                emissionUnit={results?.emissionUnit}
                            />
                        </Grid>
                    ))}
                </Grid>
            </Grid>
        </Paper >
    )
}

export default Tables